<div class="input-group form-tag" (click)="fnOpenCreateTagPanel()">
    <input type="text" [formControl]="formControl" [formlyAttributes]="field" style="display: none;">
    <img class="icons" [src]="ICONS.TAG" alt="" />
    <p class="tag-text">{{ 'tag' | translate }}</p>
    @if(formControl.value && formControl.value.length > 0){<span class="badge-pill">
        {{formControl.value.length}}
    </span>}
</div>

@if(showCreateTagPanel){<create-tag-panel [inputData]="inputModel"
    (closePanelEvent)="fnCloseCreateTagPanel($event)" (selectItemEvent)="fnSelectCreateTag($event)"></create-tag-panel>}
